import type { RoomI18nInput } from "@/lib/gql/__generated__/graphql";

import type { ProductRoomI18nFormModel } from "../../../type";

type Props = {
	viewModel: ProductRoomI18nFormModel["ViewModel"];
};

export const viewModelToRoomI18nInputConverter = ({ viewModel }: Props): RoomI18nInput => {
	const roomI18nInput: RoomI18nInput = {
		hotelID: viewModel.hotelID,
		roomID: viewModel.roomID,
		lang: viewModel.lang,
		catchCopy: viewModel.catchCopy.value,

		name: viewModel.name.value,

		address: {
			city: viewModel.address?.city?.value,
			nationality: viewModel.address?.nationality?.value,
			other: viewModel.address?.other?.value,
			postalCode: viewModel.address?.postalCode?.value,
			pref: viewModel.address?.pref?.value,
			state: viewModel.address?.state?.value,
			town: viewModel.address?.town?.value,
		},
		description: viewModel.description.value,
	} satisfies RoomI18nInput;

	return roomI18nInput;
};
